import { Modal, Button, Form } from 'react-bootstrap';
import { getDisplayDateIST } from '../../utils/helper';

const STATUS_OPTIONS = [
  { label: 'Order Placed', value: 'Order Placed' },
  { label: 'Order Confirmed', value: 'Order Confirmed' },
  { label: 'Processing', value: 'Processing' },
  { label: 'Packed', value: 'Packed' },
  { label: 'Shipped', value: 'Shipped' },
  { label: 'Out for Delivery', value: 'Out for Delivery' },
  { label: 'Delivered', value: 'Delivered' },
  { label: 'Received', value: 'Received' },
  { label: 'Re-delivered', value: 'Redelivered' },
  { label: 'Cancelled', value: 'Cancelled' },
];

const LOCKED_STATUSES = ['Delivered', 'Received', 'Redelivered'];

const StatusUpdateModal = ({
  isOpen,
  onClose,
  status,
  onStatusChange,
  remark,
  onRemarkChange,
  onSubmit,
  orderRecords = [],
  currentStatus,
}) => {
  const isLocked = LOCKED_STATUSES.includes(currentStatus);

  return (
    <Modal show={isOpen} onHide={onClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Update Status</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {orderRecords.length > 0 && (
          <div className="mb-4">
            <Form.Label className="fw-bold">Order Status Timeline</Form.Label>
            <div style={{ maxHeight: '260px', overflowY: 'auto', paddingTop: '4px' }}>
              {[...orderRecords].reverse().map((record, index, arr) => {
                const isLatest = index === 0;
                const isLast = index === arr.length - 1;
                return (
                  <div key={index} style={{ display: 'flex' }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        marginRight: '12px',
                      }}
                    >
                      <div
                        style={{
                          width: '12px',
                          height: '12px',
                          borderRadius: '50%',
                          backgroundColor: isLatest ? '#0d6efd' : '#28a745',
                          flexShrink: 0,
                          marginTop: '4px',
                        }}
                      />
                      {!isLast && (
                        <div
                          style={{
                            width: '2px',
                            flex: 1,
                            minHeight: '28px',
                            backgroundColor: '#dee2e6',
                          }}
                        />
                      )}
                    </div>
                    <div style={{ paddingBottom: '18px', flex: 1 }}>
                      <div className="d-flex justify-content-between align-items-start">
                        <span className="fw-semibold">{record.status}</span>
                        <small className="text-muted text-nowrap ms-3">
                          {getDisplayDateIST(record.date, 'DD-MM-YYYY | hh:mm A')}
                        </small>
                      </div>
                      {record.remarks && (
                        <div className="text-muted small mt-1">
                          {record.remarks}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {!isLocked && (
          <>
            <Form.Group className="mb-3" controlId="voucherStatusSelect">
              <Form.Label>Status</Form.Label>
              <Form.Select value={status} onChange={onStatusChange}>
                <option value="" disabled>
                  Select status
                </option>
                {STATUS_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group controlId="voucherRemarkTextarea">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter remark..."
                value={remark}
                onChange={onRemarkChange}
                maxLength={250}
              />
              <div className="text-muted small mt-1 text-end">
                {remark?.length || 0}/250
              </div>
            </Form.Group>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        {!isLocked && (
          <Button
            variant="primary"
            onClick={onSubmit}
            disabled={!status || !remark}
          >
            Update
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default StatusUpdateModal;
